/**
 * @owner @Appboy/frontend-ix
 */
import { v4 } from "uuid";

export const uuidv4 = (): string => {
  return v4();
};
